import { useState, useRef, useEffect } from "react"

export const useTooltip = () => {
  const [showInfo, setShowInfo] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState(null)
  const infoIconRef = useRef(null)
  const infoTooltipRef = useRef(null)
  const hideTooltipTimeoutRef = useRef(null)

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (hideTooltipTimeoutRef.current) {
        clearTimeout(hideTooltipTimeoutRef.current)
      }
    }
  }, [])

  // Compute tooltip position when it becomes visible
  useEffect(() => {
    if (showInfo && infoIconRef.current && infoTooltipRef.current) {
      const iconRect = infoIconRef.current.getBoundingClientRect()
      const tooltipRect = infoTooltipRef.current.getBoundingClientRect()
      const viewportHeight = window.innerHeight
      
      // Calculate vertical positioning to keep tooltip in viewport
      let topPosition = iconRect.top
      
      // If tooltip would extend below viewport, adjust position
      if (topPosition + tooltipRect.height > viewportHeight) {
        // Position tooltip so its bottom aligns with viewport bottom (with padding)
        topPosition = Math.max(12, viewportHeight - tooltipRect.height - 12)
      }
      
      setTooltipPosition({
        top: topPosition,
        left: iconRect.right + 8,
      })
    }
  }, [showInfo])

  const handleInfoMouseEnter = () => {
    // Clear any pending hide timeout
    if (hideTooltipTimeoutRef.current) {
      clearTimeout(hideTooltipTimeoutRef.current)
      hideTooltipTimeoutRef.current = null
    }
    setShowInfo(true)
  }

  const handleInfoMouseLeave = () => {
    // Delay hiding to allow moving to tooltip
    hideTooltipTimeoutRef.current = setTimeout(() => {
      setShowInfo(false)
    }, 100)
  }

  const handleTooltipMouseEnter = () => {
    // Clear any pending hide timeout
    if (hideTooltipTimeoutRef.current) {
      clearTimeout(hideTooltipTimeoutRef.current)
      hideTooltipTimeoutRef.current = null
    }
    setShowInfo(true)
  }

  const handleTooltipMouseLeave = () => {
    // Delay hiding to allow moving back to icon
    hideTooltipTimeoutRef.current = setTimeout(() => {
      setShowInfo(false)
    }, 100)
  }

  return {
    showInfo,
    tooltipPosition,
    infoIconRef,
    infoTooltipRef,
    handleInfoMouseEnter,
    handleInfoMouseLeave,
    handleTooltipMouseEnter,
    handleTooltipMouseLeave,
  }
}
